import { ELEVATE_USER_BY_ID } from "../api-services/ApiEndpoints";

export const elevateUserToAdmin = async (userId) => {
    const url = `${process.env.REACT_APP_API_URL}${ELEVATE_USER_BY_ID.replace('{id}', userId)}`;
    const token = localStorage.getItem('token');
    
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'accept': 'application/json'
        }
    });
    
    if (!response.ok) {
        throw new Error(`Failed to elevate user: ${response.status}`);
    }
    
    return await response.json();
};